import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrincesInTowerProject = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="bg-dark min-h-screen">
      {/* Back Button */}
      <div className="fixed top-24 left-6 md:left-12 z-40">
        <Link 
          to="/#projects" 
          className="inline-flex items-center gap-2 text-cream hover:text-cream/70 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm uppercase tracking-wider">Back</span>
        </Link>
      </div>

      {/* Title Section */}
      <section className="pt-32 pb-8 px-6 md:px-12">
        <div className="max-w-5xl mx-auto text-center">
          <h1 
            className="text-5xl md:text-7xl lg:text-8xl uppercase text-cream mb-4"
            style={{ fontFamily: 'Anton, sans-serif' }}
          >
            Princes in the Tower
          </h1>
          <p className="text-xl md:text-2xl text-cream">
            Tower of London
          </p>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-8 px-6 md:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
            <iframe
              src="https://player.vimeo.com/video/343041556?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              className="absolute top-0 left-0 w-full h-full"
              title="The Princes in the Tower"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* Back to Films Button */}
      <section className="py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <Link 
            to="/#projects"
            className="inline-block rounded-full border-2 border-cream px-8 py-3 text-sm uppercase tracking-widest text-cream hover:bg-cream hover:text-dark transition-all duration-300"
          >
            Back to Films
          </Link>
        </div>
      </section>
    </div>
  );
};

export default PrincesInTowerProject;
